import { MatchScores } from "PFApp/components/match_scores";
import { RoleProfileActionButtonsWrapper } from "PFApp/components/role_profile_action_buttons";
import { Flex } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";

import { AddToComparisonButton } from "../../components/add_to_comparison_button";
import { useMatchCardContext } from "../../match_card_context";
import css from "./match_card_header.module.scss";
import { MatchProfileInfo } from "./match_profile_info";
import { MatchStatusIcons } from "./match_status_icons";

export const MatchCardHeader = () => {
  const {
    role,
    profile,
    shortlist,
    isFillDisabled,
    allowCompare,
    areButtonsDisabled,
    isShortlistTabActive,
    isOnMatchesTab,
    removeProfileFromComparison,
    scores,
    isCompressed
  } = useMatchCardContext();

  return (
    <div className={css.header}>
      <div className={css.matchStatus}>
        <MatchScores
          normalizedScore={scores.normalizedScore}
          availabilityScore={scores.availabilityScore}
          wrap={!isCompressed}
        />
        <MatchStatusIcons />
      </div>
      <Divider type="vertical" />
      <Flex
        grow={1}
        direction={isCompressed ? "column" : "row"}
        gap={isCompressed ? "spacingLg" : "spacingMd"}
        wrap="wrap"
        justifyContent="space-between"
      >
        <MatchProfileInfo />
        <RoleProfileActionButtonsWrapper
          role={role}
          profile={profile}
          shortlist={shortlist}
          isFillDisabled={isFillDisabled}
          customButton={allowCompare && <AddToComparisonButton />}
          areButtonsDisabled={areButtonsDisabled}
          isShortlistTabActive={isShortlistTabActive}
          isOnMatchesTab={isOnMatchesTab}
          removeProfileFromComparison={removeProfileFromComparison}
          named={isShortlistTabActive}
          className={isCompressed ? css.buttonsCompressed : undefined}
        />
      </Flex>
    </div>
  );
};
